import { createDemoState } from './seed';
import type { AppAction, AppState, User } from './types';

const STATE_KEY = 'fan-dazi.demo-state.v1';
const SESSION_KEY = 'fan-dazi.session.v1';

export function getLocalSession(): string | null {
  return localStorage.getItem(SESSION_KEY);
}

export function clearLocalSession(): void {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(STATE_KEY);
}

export function localJoin(displayName: string, avatar: string, avatarColor: string): AppState {
  const user: User = {
    id: crypto.randomUUID(),
    displayName,
    avatar,
    avatarColor,
    role: 'OWNER',
    joinedAt: new Date().toISOString(),
  };
  const state = createDemoState(user);
  localStorage.setItem(SESSION_KEY, `demo-${user.id}`);
  save(state);
  return state;
}

export function loadLocalState(): AppState | null {
  const raw = localStorage.getItem(STATE_KEY);
  return raw ? (JSON.parse(raw) as AppState) : null;
}

function save(state: AppState): AppState {
  const next = { ...state, version: state.version + 1, updatedAt: new Date().toISOString() };
  localStorage.setItem(STATE_KEY, JSON.stringify(next));
  return next;
}

export function reduceLocal(state: AppState, action: AppAction): AppState {
  const now = new Date().toISOString();
  const userId = state.currentUser.id;
  switch (action.type) {
    case 'FAVORITE_TOGGLE': {
      const existing = state.favorites.find((item) => item.restaurantId === action.payload.restaurantId);
      return save({
        ...state,
        favorites: existing
          ? state.favorites.filter((item) => item.restaurantId !== action.payload.restaurantId)
          : [...state.favorites, { restaurantId: action.payload.restaurantId, createdByUserId: userId, createdAt: now, supporterUserIds: [] }],
      });
    }
    case 'SUPPORT_TOGGLE':
      return save({
        ...state,
        favorites: state.favorites.map((item) => {
          if (item.restaurantId !== action.payload.restaurantId) return item;
          const supported = item.supporterUserIds.includes(userId);
          return { ...item, supporterUserIds: supported ? item.supporterUserIds.filter((id) => id !== userId) : [...item.supporterUserIds, userId] };
        }),
      });
    case 'RATE_RESTAURANT': {
      const ratings = state.ratings.filter((item) => !(item.restaurantId === action.payload.restaurantId && item.userId === userId));
      ratings.push({ id: crypto.randomUUID(), userId, createdAt: now, ...action.payload });
      return save({ ...state, ratings });
    }
    case 'CREATE_MEAL':
      return save({
        ...state,
        meals: [...state.meals, { id: crypto.randomUUID(), creatorUserId: userId, createdAt: now, ...action.payload }],
      });
    case 'CREATE_DRAW':
      return save({
        ...state,
        draws: [...state.draws, { id: crypto.randomUUID(), userId, createdAt: now, ...action.payload }],
      });
    case 'PROFILE_UPDATE': {
      const currentUser = { ...state.currentUser, ...action.payload };
      return save({ ...state, currentUser, users: state.users.map((user) => user.id === userId ? currentUser : user) });
    }
  }
}
